import React, { createContext, useContext, useState, useEffect } from "react";

interface SupporterContextType {
  isProSupporter: boolean;
  setIsProSupporter: (value: boolean) => void;
}

const SupporterContext = createContext<SupporterContextType | undefined>(undefined);

export function SupporterProvider({ children }: { children: React.ReactNode }) {
  const [isProSupporter, setIsProSupporterState] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem("pdfworkspace-pro-supporter");
    if (saved === "true") {
      setIsProSupporterState(true);
      document.documentElement.classList.add("pro-theme");
    }
  }, []);

  const setIsProSupporter = (value: boolean) => {
    setIsProSupporterState(value);
    if (value) {
      localStorage.setItem("pdfworkspace-pro-supporter", "true");
      document.documentElement.classList.add("pro-theme");
    } else {
      localStorage.removeItem("pdfworkspace-pro-supporter");
      document.documentElement.classList.remove("pro-theme");
    }
  };

  return (
    <SupporterContext.Provider value={{ isProSupporter, setIsProSupporter }}>
      {children}
    </SupporterContext.Provider>
  );
}

export function useSupporter() {
  const context = useContext(SupporterContext);
  if (context === undefined) {
    throw new Error("useSupporter must be used within a SupporterProvider");
  }
  return context;
}
